import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyALeTgHk8_4nvmOI3eu9K_LOIQX8fVru6A",
  authDomain: "bongogames.firebaseapp.com",
  projectId: "bongogames",
  storageBucket: "bongogames.firebasestorage.app",
  messagingSenderId: "799817079388",
  appId: "1:799817079388:web:de9d12d3d5c615b3582499",
  measurementId: "G-9GW2NB4R88",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, googleProvider);
  const token = await result.user.getIdToken();
  return { token, user: result.user };
}
